import {getDomain} from "../client-config.js"

let urlhost = window.location.host;
let subDomain = urlhost.split('.')[0];
// var loopBackDomain = 'http://localhost';
var loopBackDomain = getDomain(subDomain)
var Domain =  'http://icapidilite-excel.esealcom.com:3005';
var loopBackPort = (subDomain === 'vguard' || subDomain === 'valvoline' || subDomain === 'admin')? 3006 : 3002;
//var loopBackPort = subDomain === 'valvoline' ? 3006 : 3002;


export  {
    loopBackDomain,
    loopBackPort,
    Domain
}
